import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZDrawScheduleSelect, ZDrawTypePlanSelect } from '../draw/draw/models';
import { ZDrawOrderSelect } from '../draw/drawOrder/models';
import { ZOrderSelect } from '../order/models';
import { successSchema } from '../utils';
import {
  ZSubscriptionHistorySelect,
  ZSubscriptionRunSelect,
  ZSubscriptionSelect,
} from './models';

const c = initContract();
export const adminSubscriptionContract = c.router(
  {
    getSubscriptionsForPlayer: {
      method: 'GET',
      path: '/player/:player_id',
      pathParams: z.object({
        player_id: z.string(),
      }),
      responses: {
        200: z.array(
          z.object({
            order: ZOrderSelect,
            drawOrder: ZDrawOrderSelect,
            subscription: ZSubscriptionSelect,
            drawSchedulePlans: z
              .object({
                drawSchedule: ZDrawScheduleSelect,
                drawTypePlan: ZDrawTypePlanSelect,
              })
              .array(),
            subscriptionRun: z.nullable(ZSubscriptionRunSelect),
            runDrawOrder: z.nullable(ZDrawOrderSelect),
            lastPurchasedDrawId: z.number().nullable(),
          }),
        ),
      },
    },

    getSubscriptionChanges: {
      method: 'GET',
      path: '/:subscription_id/changes',
      pathParams: z.object({
        subscription_id: z.string(),
      }),
      responses: {
        200: z.array(ZSubscriptionHistorySelect),
      },
    },

    processSubscriptionForPlayer: {
      method: 'POST',
      path: '/:subscription_id/process',
      pathParams: z.object({
        subscription_id: z.string(),
      }),
      body: z.object({}),
      responses: {
        200: z.object({
          success: z.boolean(),
          message: z.string().optional(),
        }),
        400: c.type<{ message: string }>(), // player not found or no subscription
      },
    },

    cancelSubscriptionForPlayer: {
      method: 'POST',
      path: '/:subscription_id/cancel',
      pathParams: z.object({
        subscription_id: z.string(),
      }),
      body: z.object({}),
      responses: {
        200: successSchema,
        400: c.type<{ message: string }>(), // player not found or no subscription
      },
    },
  },
  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
